const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-footer-newsletter'] = {
        c: () => require('partner/modules/dobbies-footer-newsletter/dobbies-footer-newsletter.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-footer-newsletter',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-footer-newsletter'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-footer-newsletter|dobbies-footer-newsletter'] = {
                c: () => require('partner/modules/dobbies-footer-newsletter/dobbies-footer-newsletter.view.tsx'),
                cn: '__local__-__local__-dobbies-footer-newsletter'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };